import React, { useEffect, useState } from "react";
import styles from "./listCard.module.css";
import NumberFormat from "react-number-format";
import { useRouter } from "next/router";
import { selectors as ListingsReducerSelectors } from "../../../../../redux/slices/v2/ListingReducer";
import { useSelector } from "react-redux";
import formatUrl from "utils/FormatUrl";
import useTranslation from "next-translate/useTranslation";
import { linkSearchItems, norm } from "../../ListingsRouterUrlHelper";
import { province_to_slug } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import { filter } from "lodash";

function index({ totalListingsCount }: { totalListingsCount: number }) {
  const mapVsListSlct = useSelector(ListingsReducerSelectors.mapVsListSelactor);
  // const route = useRouter();

  // const handleLinksRedirect = (typeRedirect:string) => {
  //     const { surfacemin, surfacemax, prixmin, typologie, type } = route.query;

  //     const newURL = `http://localhost:3000/fr/${typeRedirect}.htm?surfacemin=${surfacemin}&surfacemax=${surfacemax}&prixmin=${prixmin}&typologie=${typologie}&type=${type}`;

  //     window.location.href = newURL;
  // }

  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const { lang, t } = useTranslation("annonceAchat");

  const handleLinksRedirect = (typeRedirect: string) => {
    // const queryParams = window.location.search.slice(1);
    // const newLink = `/fr/${typeRedirect}.htm?${queryParams}`;
    // window.location.href = newLink;
    const {
      region,
      controlBy,
      meublee,
      no_trigger_search,
      page,
      ...filteredPayload
    } = searchPayload;

    let copySP = {};
    if (filteredPayload.bounds) {
      copySP["bounds"] = [
        filteredPayload.bounds._sw.lat,
        filteredPayload.bounds._sw.lng,
        filteredPayload.bounds._ne.lat,
        filteredPayload.bounds._ne.lng,
      ];
      if (filteredPayload.exclusivite) {
        copySP["exclusivite"] = filteredPayload.exclusivite;
      }
    } else if (window) {
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          copySP["lat"] = window.cartedesannonces.getCenter().lat;
          copySP["lng"] = window.cartedesannonces.getCenter().lng;
          copySP["zoom"] = window.cartedesannonces.getZoom();
          copySP["bounds"] = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      }
    }

    linkSearchItems.map((item) => {
      if (
        (filteredPayload[item] && filteredPayload[item].length) ||
        (typeof filteredPayload[item] == "number" &&
          parseInt(filteredPayload[item].toString()))
      ) {
        copySP[item] = filteredPayload[item];
      }
    });
    if (filteredPayload["province"]) {
      copySP["province"] = province_to_slug[filteredPayload["province"]];
    }
    copySP["zoom"] = searchPayload.zoom ? searchPayload.zoom : 8;

    copySP["commune"] = searchPayload.commune
      ? norm(searchPayload.commune)
      : "";
    copySP["vendu"] = filteredPayload["vendu"];
    const u = new URLSearchParams(copySP).toString();

    let link = `/${lang}/${typeRedirect}.htm${u ? `?${u}` : ""}`;

    return link;
    // window.location.href = newLink;
  };

  return (
    <div className={styles.listeCarte1}>
      {/* <div className={styles.listeCarteChild} /> */}
      <a
        className={
          mapVsListSlct == "LIST" ? styles.listeSelected : styles.liste
        }
        // onClick={()=>{
        //     handleLinksRedirect("list")
        // }}
        data-tracking="click"
        data-value=""
        rel="noindex,nofollow"
        href={handleLinksRedirect("list")}
      >
        <span>{t("Liste")}</span>
      </a>
      <a
        className={mapVsListSlct == "MAP" ? styles.listeSelected : styles.liste}
        rel="noindex,nofollow"
        href={handleLinksRedirect("map")}
        data-tracking="click"
        data-value=""
      >
        <span>
          {t("Carte")}
          {/* (
          <NumberFormat
            displayType={"text"}
            value={totalListingsCount}
            thousandSeparator={" "}
          />
          ) */}
        </span>
      </a>
    </div>
  );
}

export default index;
